import ReviewHighLightsSection, { ReviewHighLightsSectionProps } from './ReviewHighLightsSection'
export default ReviewHighLightsSection
export { ReviewHighLightsSection }
export type { ReviewHighLightsSectionProps }
